//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const $ = require('jquery');
import _ from 'lodash';
import assert from 'assert';
import {reorderTasks, getAncestorIds} from '../ordered-relation.js';
import {elementsPreviewsSet} from '../component-registers.js'
import OmicronDnd from '../omicron/omicron-dnd.js';
import {addOrganizerLinkToDescription} from '../gcalendar-utils'

export default {
  props: ['handle'],
  data() {
    return {
      beforeUpdateActions: [],
      isMobile: (('ontouchstart' in window) ||
                 (window.navigator.msMaxTouchPoints > 0)),
      // TODO: Add lastReorder as in Organizer 1 so that these spurious
      //       clicks-on-drop-back can be prevented.
    };
  },
  methods: {
    initDragAndDrop() {
      let selectionDragInfos = [];
      OmicronDnd.init(this.$el, {
        draggableSelector: '.draggable-task',
        filterSelector: '.md-checkbox,.undraggable,.md-button,.bottom-filler,.top-filler',
        handleSelector: this.handle,
        enterGuardLeft: 0,
        enterGuardRight: this.handle ? 0.52 : 0,

        forbiddenInsertionIndicesFn: (containerEl, activeEl) => {
          if (this.dragWouldCreateCycle(containerEl, activeEl)) {
            // Mark all possible indices as bad, including the end (hence <=).
            const result = [];
            for (let i = 0; i <= containerEl.children.length; ++i) {
              result.push(i);
            }
            return result;
          }
          const result = [];
          if (containerEl.firstElementChild &&
              containerEl.firstElementChild.dataset.placementInfo === 'header') {
            result.push(0);
          }
          // Note: we are allowed to repeat the indices, so we can have
          // a bunch of conditions and just spit numbers whenever we fell
          // like this. No penalty for numbers outside the range or out of
          // order.
          // TODO: Handle all the section header and so on crap, if any
          // still left.
          for (let i = 0; i < containerEl.children.length; ++i) {
            if (containerEl.children[i].classList.contains('top-filler') ||
                containerEl.children[i].classList.contains('drop-zone-frame')) {
              result.push(i);
            } else if (containerEl.children[i].classList.contains('bottom-filler')) {
              result.push(i + 1);
            }
            if (containerEl.children[i].classList.contains('ellipsis')) {
              result.push(i, i + 1);
            }
          }
          return result;
        },
        onFloatElementCreated: (floatEl) => {
          const hovBtns = floatEl.querySelector('.hover-buttons');
          if (hovBtns) {
            hovBtns.remove();
          }
          if (!this.$taskCardsController.selectedTasksIds) {
            return;
          }
          const selCount =
              Object.keys(this.$taskCardsController.selectedTasksIds).length;
          if (selCount <= 1) {
            return;
          }
          const selectionDragInfo = document.createElement('div');
          selectionDragInfos.push(selectionDragInfo);
          selectionDragInfo.classList.add('selection-drag-info');
          const translated = this.$ngettext('%{ n } item',
                                            '%{ n } items', selCount);
          const interpolated =
              this.$gettextInterpolate(translated, {n: selCount});
          selectionDragInfo.textContent = interpolated;
          floatEl.append(selectionDragInfo);
        },
        onContainerEntered: () => {
          this.$emit('containerEntered');
        },
        onContainerLeft: () => {
          this.$emit('containerLeft');
        },
        onDragStart: () => {
          this.$root.dragStart();
          for (const elementsPreview of elementsPreviewsSet) {
            elementsPreview.onDragStarted();
          }
        },
        onDragFinished: () => {
          this.$root.dragEnd();
          for (const selectionDragInfo of selectionDragInfos) {
            selectionDragInfo.remove();
          }
          selectionDragInfos = [];
          for (const elementsPreview of elementsPreviewsSet) {
            elementsPreview.onDragFinished();
          }
        },
        onInternalChange: (event) => {
          this.handleSortableReorder(event);
        },
        onDropToOtherContainer: (event) => {
          this.handleSortableReorder(event);
        },
      });
    },
    reorder(movedTaskElement, placementDataset) {
      const srcRelation = movedTaskElement.dataset.parentRelation;
      const destRelation = placementDataset.parentRelation;
      console.log(placementDataset.labelFilter)
      let newParentPtr;
      let insertBeforePos;
      if (placementDataset.placementInfo) {
        newParentPtr = {
          parentClass: placementDataset.parentClass,
          parentKey: placementDataset.parentKey,
        };
        if (placementDataset.placementInfo === 'header' ||
            placementDataset.insertAt === 'begin') {
          insertBeforePos = 0;
        } else {
          insertBeforePos = null; // Insert at the end.
        }
      } else {
        const putAfterTask =
            this.$reactiveCache.docs[placementDataset.taskId];
        assert(putAfterTask);
        newParentPtr = {
          parentClass: putAfterTask[destRelation].parentClass,
          parentKey: putAfterTask[destRelation].parentKey,
        };
        insertBeforePos = Number(placementDataset.idx) + 1;
      }

      const draggedTaskId = movedTaskElement.dataset.taskId;
      let movedTasksIds = [draggedTaskId];
      if (this.$taskCardsController.selectedTasksIds &&
          this.$taskCardsController.selectedTasksIds[draggedTaskId]) {
        movedTasksIds =
            Object.keys(this.$taskCardsController.selectedTasksIds);
      }
      // Fetch the tasks to move from the cache. Remove old relations when
      // moving a task between main board and another task.
      const tasks = movedTasksIds.map((id) => {
        const task = this.$reactiveCache.docs[id].clone();
        if (srcRelation != destRelation) {
          // put item in the same topic list as its parent when it's planned out.
          if (srcRelation === "subtaskOf"
              && destRelation === "plannedFor"
              && task.subtaskOf.parentClass === 'task') {
            const parent = this.$reactiveCache.docs[task.subtaskOf.parentKey]
            task.subtaskOf = parent.subtaskOf;
          } else {
            delete task.plannedFor;
            delete task.subtaskOf;
          }
        }
        // clear "being in backlog" when moving stuff around in topic view.
        if (srcRelation === "subtaskOf"
            && destRelation === "subtaskOf"
            && task.plannedFor
            && task.plannedFor.parentClass === 'list') {
          delete task.plannedFor;
        }
        return task;
      });
      if (destRelation === "subtaskOf") {
        const parent = this.$reactiveCache.docs[newParentPtr.parentKey]
        if (parent.type === "event") {
          addOrganizerLinkToDescription(parent)
        }
      }
      if (placementDataset.labelFilter) {
        for (const task of tasks) {
          if (placementDataset.labelFilter !== "noLabel") {
            if (!task.labels) {
              task.labels = [placementDataset.labelFilter]
            } else if (!task.labels.includes(placementDataset.labelFilter)) {
              task.labels.push(placementDataset.labelFilter)
            }
          } else {
            task.labels = undefined;
          }
        }
      }
      for (const task of tasks) {
        reorderTasks({
          relation: destRelation,
          reactiveCache: this.$reactiveCache,
          tasks: [task],
          newPPtr: newParentPtr,
          insertPos: insertBeforePos,
          skipOrdered: false,
        }).catch((error) => {
          // TODO: Show the error in UI, handle it sensibly.
          console.error(error);
        });
      }
    },
    handleSortableReorder(event) {
      // `event.item` is the moved element, and it is already inserted in the
      // new place, so that event.item.previousElementSibling can be used to
      // get the preceding task/section. This may be complicated by some
      // special elements getting in the way, so we attempt to skip them.
      // In case we are at the very top pf the container, we may find nothing,
      // in which case we will take the data from the container.
      let putAfterElement = event.item.previousElementSibling;
      // Skip elements without the right data set on them.
      while (putAfterElement &&
             !putAfterElement.dataset.placementInfo &&
             !putAfterElement.dataset.taskId) {
        putAfterElement = putAfterElement.previousElementSibling;
      }
      const placementDataset =
          (putAfterElement || event.item.parentElement).dataset;

      if (!placementDataset.placementInfo && !placementDataset.taskId) {
        // There is no suitable placementDataset for this drop spot.
        // This might happen at the top of the list-view (at least, it
        // happened historically). Simply revert the drag, as we can't
        // meaningfully implement it.
        console.warn('No placement info found for reorder event:', event);
        this.revertSortableReorder(event);
        return;
      }
      if (this.dragWouldCreateCycle(event.to, event.item)) {
        console.warn(
          'Cannot drop an item inside itself:',
          this.$taskCardsController.selectedTasksIds,
          event
        );
        this.revertSortableReorder(event);
        return;
      }

      if (this.teamMismatch(event.to, event.item, placementDataset.parentRelation)) {
        console.warn(
          'Mismatching teams:',
          this.$taskCardsController.selectedTasksIds,
          event
        );
        alert(this.$gettext('Target belongs to a different team.'))
        this.revertSortableReorder(event);
        return;
      }

      // Dragging the element made actual DOM inconsistent with Vue's virtual
      // DOM. This can result in Vue making DOM update incorrectly. To prevent
      // that, we revert the drag. However, if we reverted the move
      // immediately, the element would be visibly moved back and then again
      // to the new place. To prevent this flickering, we defer the revert
      // action to just before Vue updates DOM in one of the parent elements.
      //
      // Before it's hard to tell which tasks-list will get updated first,
      // I schedule triggers on both, and the first one will trigger reverting
      // the dom change.
      const revertFunc = _.once(() => {
        this.revertSortableReorder(event);
      });
      event.item.classList.add('has-revert-action');
      event.item.revertAction = revertFunc;
      this.beforeUpdateActions.push(revertFunc);

      this.reorder(event.item, placementDataset);

      // Since elements inside a card cannot be selected in the interface,
      // it would be very confusing if elements moved from "toplevel" inside
      // a card continued to be selected. However, ignore the case when
      // someone simply reorders elements inside cards while having something
      // else selected (I don't see why someone could want to do that, but I
      // expect it may be done by mistake).
      if (event.to.matches('.tasks-list.element-list') &&
          !event.from.matches('.tasks-list.element-list')) {
        this.$taskCardsController.leaveSpecialState()
      }
    },
    revertSortableReorder(event) {
      // There's a weird edge case when the inserted element is placed
      // after the ghost/clone element created by Sortable, and then after
      // the clone is removed, event.newIndex starts pointing beyond the
      // end of the event.to.children list.
      const realNewIndex =
          Math.min(event.newIndex, event.to.children.length-1);
      if (event.from === event.to && event.newIndex <= event.oldIndex) {
        event.from.insertBefore(
            event.to.children[realNewIndex],
            event.from.children[event.oldIndex].nextSibling);
      } else {
        event.from.insertBefore(
            event.to.children[realNewIndex],
            event.from.children[event.oldIndex]);
      }
    },
    dragWouldCreateCycle(container, item) {
      const parentId = container.dataset.parentKey;
      if (parentId) {
        const movedTasksIds =
            this.$taskCardsController.selectedTasksIds ||
                {[item.dataset.taskId]: true};
        for (const ancestorId of
              getAncestorIds(
                  this.$reactiveCache, parentId, true)) {
          if (ancestorId in movedTasksIds) {
            return true;
          }
        }
      }
      return false;
    },
    teamMismatch(container, item, relation) {
      const parentID = container.dataset.parentKey;
      const itemID = item.dataset.taskId;
      console.log(relation, parentID, itemID)
      if (relation && relation === 'subtaskOf' && parentID && itemID) {
        const parentCouch = this.$reactiveCache.docs[parentID]?.couch
        const itemCouch = this.$reactiveCache.docs[itemID]?.couch
        if (parentCouch !== itemCouch) return true;
      }
      return false;
    },
  },
  mounted() {
    this.initDragAndDrop();
  },
  beforeUpdate() {
    for (const action of this.beforeUpdateActions) {
      action();
    }
    this.beforeUpdateActions = [];

    $('.has-revert-action', this.$el).each((i, el) => {
      el.revertAction();
      delete el.revertAction;
      el.classList.remove('has-revert-action');
    });
  },
};
